import { UIIcon } from '../config/icons';
import { ABFilterBar } from '../lib/ab/filter-bar';
import { ABCountrySelect } from '../lib/ab/select-admin';
import { ABObjectCount } from '../lib/ab/widgets-admin';
import { CCity, c_cities } from '../lib/mdl/c-city';
import { makeActionButton } from '../lib/ui/component/button';
import { UINumberInput, UITextInput } from '../lib/ui/component/input';
import { UILabeled } from '../lib/ui/component/labeled';
import { UITable, UITableDefinition } from '../lib/ui/component/table';
import { uiToast } from '../lib/ui/component/toast';
import { UICheckbox } from '../lib/ui/component/toggle';
import { $el } from '../lib/ui/elements';
import { $fmt } from '../lib/ui/fmt';
import { UIScreen } from '../lib/ui/screen';
import { UIViewSpec } from '../lib/ui/view';
import { YArrayDataSource } from '../lib/y/data-source';
import { xavis_experiments } from '../lib/y/debug';
import { $form } from '../lib/y/form';
import { $location } from '../lib/y/location';

class CityScreen extends UIScreen {
    private _city?: CCity;

    constructor(city?: CCity) {
        super();

        this._city = city;
        this.title = city?.name || 'New city';
    }

    protected override fillContent(content: UIViewSpec): void {
        const city = this._city;

        const name = new UITextInput({ required: true });
        const country = new ABCountrySelect({ required: true });
        const slug = new UITextInput({ required: true });
        const lat = new UINumberInput({ decimal: true, required: true });
        const lng = new UINumberInput({ decimal: true, required: true });
        const can_signup = new UICheckbox({ title: 'Signup' });
        const show_for_producers = new UICheckbox({ title: 'Show for producers' });
        const timezone = new UITextInput({ required: true });

        const form = $form({ name, country, slug, location: $form({ lat, lng }), can_signup, show_for_producers, timezone });

        if(city) {
            form.value = city;
            country.disabled = true;
        } else {
            timezone.value = 'Europe/Berlin';
        }

        const section = $el.FORM('ui-section w-form l-form', [
            new UILabeled(name, { above: 'Name' }),
            new UILabeled(country, { above: 'Country' }),
            new UILabeled(slug, { above: 'Slug' }),
            $el.DIV('l-input-row', [
                new UILabeled(lat, { above: 'Latitude' }),
                new UILabeled(lng, { above: 'Longitude' })
            ]),
            can_signup,
            show_for_producers,
            xavis_experiments && new UILabeled(timezone, { above: 'Timezone' }),
        ]);

        content.ui_add([
            section,
            makeActionButton(UIIcon.THUMBS_UP, city ? 'Update' : 'Create', () => {
                if(!form.validate()) return;

                c_cities.upsert(city && city.id, form.value).then(() => {
                    $location.pop();
                }, uiToast);
            })
        ]);
    }
}

export class AdminCitiesScreen extends UIScreen {
    protected override fillContent(content: UIViewSpec): void {
        const doSearch = () => {
            let cities = filter_bar.search_input!.filterArray(c_cities.all, (c, w) => {
                if(c.name.toLowerCase().includes(w)) return true;
                if(c.slug.toLowerCase().includes(w)) return true;
                return false;
            });

            count.number = cities.length;
            source.data = cities;
        };

        const def = new UITableDefinition<CCity>();
        def.addValue(c => c.name, { title: 'Name', width: 200 });
        def.addValue(c => c.slug, { title: 'Slug', width: 200 });
        def.addValue(c => c.can_signup, $fmt.CHECKMARK, { title: 'Signup', width: -80 });
        def.addValue(c => c.show_for_producers, $fmt.CHECKMARK, { title: 'Producers', width: -110 });

        def.addButtons([{
            icon: UIIcon.PENCIL, tooltip: 'Edit', action: item => {
                $location.push({ transient: new CityScreen(item) });
            }
        }], { width: -30 });

        def.preference_prefix = 'cities';

        const count = new ABObjectCount('cities');
        const filter_bar = new ABFilterBar({
            on_search: doSearch,
            right_content: [count],
            no_header: true
        })

        const source = new YArrayDataSource<CCity>;

        content.ui_add([
            $el.SECTION('pad-t-narrow', $el.DIV('tl-new-list-block m-narrow', [
                filter_bar,
                new UITable(def, source),
            ])),
            makeActionButton(UIIcon.PLUS, 'New city', () => { $location.push({ transient: new CityScreen }) })
        ]);

        doSearch();
    }
}
